import { lang } from '@umu/ukit-lang';
/**
 * @description 微信公众号引导关注
 * @author duanjun
 */

import './wechatServiceAccount.scss';

import React from 'react';
import UmuWebview from '@umu/umu-webview';
import { components } from 'common';
const { CustomDialog, PreImg } = components;

const wechatSubscribeData = (window as any).wechatSubscribeData || {
    isSubscribe: true,
}; // TODO: 获取全局模板变量

function _showDialog(type: string, title: string, qrcodeUrl: string, tips?: string) {
    // app 里打开则不显示这些微信引导
    if (UmuWebview && UmuWebview.UA_INFO.isUMUWebview) {
        return;
    }

    const content = () => {
        return (
            <div className="wechat-service-account">
                <span className={'icon icon-' + type}></span>
                <h5 className="message">{title}</h5>
                <p className="tips">{tips}</p>
                <PreImg>
                    <img className="qrcode" src={qrcodeUrl} />
                </PreImg>
            </div>
        );
    };
    CustomDialog({
        className: 'wechat-service-account-dialog',
        canClose: true,
        contentComponent: content as any,
        width: '80%',
        childProps: {},
    });
}

function follow() {
}

function commit() {
}

function checkFollowUmu() {

    // 中文里边是没有关注公众号那么就需要弹窗, 英文先全部放行

    return true;
}

const getFollowUrl = () => wechatSubscribeData.followUrl;

export default {
    follow,
    commit,
    checkFollowUmu,
    getFollowUrl,
};
